import { createStore } from 'vuex'
import DefaultAxios from '../service/default'
import StoreAxios from '../service/store'

const store = createStore({
  state(){
    return {
      rate: {
        rates: [],
        refreshTime: ''
      },
      newProductInfo: {
        type: 'new',
        id: null
      },
      newListing: {
        type: 'new',
        id: null,
        value: null
      },
      newProfitFromProductSelection:{
        type: 'new',
        id: null,
        value: null
      },
      storeList: []
    }
  },
  mutations: {
    componentChange(state, obj){
      state[obj.key] = obj.obj
    },
    setRate(state, obj){
      state.rate = obj
    },
    setStoreList(state, array){
      state.storeList.splice(0, state.storeList.length)
      array.map(obj => state.storeList.push(obj))
    }
  },
  actions:{
    async updateRate({ commit }){
      let res = await DefaultAxios.getRate()
      let result = res.data.info
      commit('setRate', result)
    },
    async updateStoreList({ commit }){
      let res = await StoreAxios.getAll()
      if(res.data.code !== 1) throw new Error(res.data.info)
      commit('setStoreList', res.data.info)
    }
  }
})

export default store
